// tslint:disable
/**
 * CONEXSYS Question Portal API
 * The API for the CONEXSYS Question Portal
 *
 * The version of the OpenAPI document: 2.0.0
 * Question: support@conexsys.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { virtualConfig as config } from '../../../config/virtual';
import { apiRequest, setEntitiesApiOperationState } from '../../../app/api';
import { QuestionHelper } from '../classes';
import moment from 'moment';
import _ from 'lodash';

import { QuestionEntities } from '../collections';
import { State_ApiOperationContextTypes } from '../../../storage';
import { UseCtx } from '../../../config/hooks';

export enum QuestionApiOperation {
	readQuestions = 'readQuestions'
}

export interface ReadQuestionsRequest {
	eventId: string;
	modifiedFrom?: string;
	ids?: string[];
	queryLimit?: number;
	queryBookmark?: string;
}

/**
 * Read questions
 */
export async function readQuestions(
	ctx: UseCtx<any>,
	requestParameters: ReadQuestionsRequest
): Promise<QuestionEntities> {
	const operationId = QuestionApiOperation.readQuestions;

	// get the attempt date now BEFORE the request is made so there is no GAP in time if the request takes awhile or fails
	const attemptDate: string = moment().toISOString();

	// make the api request
	const response = await apiRequest<QuestionEntities, ReadQuestionsRequest>(
		ctx,
		config.apiId,
		operationId,
		requestParameters
	);

	let entities: QuestionEntities | undefined = response.response.data;
	if (!entities) entities = [];

	if (entities.length > 0) {
		// set each entity.__state.eventId to the eventId from the params
		entities.forEach((entity, i, a) => {
			a[i].__state = _.merge(entity.__state || {}, {
				eventId: requestParameters.eventId
			});
		});

		// patch entities with an api success data for the operation
		setEntitiesApiOperationState<QuestionEntities, QuestionHelper>(
			ctx.virtual.question,
			entities,
			operationId,
			State_ApiOperationContextTypes.Success,
			attemptDate
		);
		// upsert the entities to the store
		ctx.virtual.question.upsert(entities);
	}

	// return the entities to the caller for direct reference
	return entities;
}
